import styled from 'styled-components';
import { typography } from '@clds/typography';
import { maxWidthVariant, tooltipTheme } from './theme';
export const TooltipPaper = styled.div.attrs({
    'data-test': 'tooltip-paper',
}) `
  background: ${tooltipTheme.paper.background};
  ${typography.xxs.regular};
  color: ${tooltipTheme.paper.color};
  border-radius: ${tooltipTheme.paper.border.radius};
  padding: ${tooltipTheme.paper.padding};
  max-width: ${maxWidthVariant((variant) => variant.maxWidth)};
  overflow-wrap: break-word;
`;
//# sourceMappingURL=Paper.js.map